var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "robot-info robot2s" }, [
    _c("div", { attrs: { id: "info-b1" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB1Visible } }, [
          _vm._v("未来之选 尽显科技")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1", class: { fadeUp: _vm.isB1Visible } },
          [_vm._v("维拉2.0      ¥18,999元/套")]
        ),
        _c(
          "div",
          { staticClass: "p3 delay1", class: { fadeDown: _vm.isB1Visible } },
          [
            _c("img", {
              attrs: { src: require("../../../assets/web/2s-img1.png") }
            })
          ]
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b2" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB2Visible } }, [
          _vm._v("语音技能")
        ]),
        _c(
          "div",
          { staticClass: "list" },
          _vm._l(_vm.b2List, function(item, index) {
            return _c(
              "div",
              {
                staticClass: "item",
                class: [{ fadeDown: _vm.isB2Visible }, "delay" + (index + 1)]
              },
              [
                _c("h3", [_vm._v(_vm._s(item.text))]),
                _c("p", [_vm._v(_vm._s(item.tag))])
              ]
            )
          })
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b3" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB3Visible } }, [
          _vm._v("亲情陪伴")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1 mt10", class: { fadeUp: _vm.isB3Visible } },
          [
            _vm._v("免接听式视频通话"),
            _c("br"),
            _vm._v("即使不在家，随时查看家里任意角落")
          ]
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b4" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB4Visible } }, [
          _vm._v("智慧家庭")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1 mt10", class: { fadeUp: _vm.isB4Visible } },
          [
            _vm._v("家庭新成员，从此多了一位生活助手。"),
            !_vm.isMobile ? _c("br") : _vm._e(),
            _vm._v(
              " 全天无休的“保安”，发现问题可以前往确认，出门在外亦可不必担忧。"
            )
          ]
        ),
        _c(
          "div",
          { staticClass: "p3 delay2", class: { fadeDown: _vm.isB4Visible } },
          [
            _vm.isMobile
              ? _c("img", {
                  attrs: { src: require("../../../assets/mobile/2s-img2.png") }
                })
              : _c("img", {
                  attrs: { src: require("../../../assets/web/2s-img2.png") }
                })
          ]
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b5" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB5Visible } }, [
          _vm._v("智慧健康")
        ]),
        _c(
          "div",
          { staticClass: "p2 delay1 mt10", class: { fadeUp: _vm.isB5Visible } },
          [
            _vm._v("多了一个关心你的机器“人”"),
            _c("br"),
            _vm._v("少了一个需要你担心的人"),
            _c("br"),
            _c("br"),
            _vm._v(
              "家人各项健康数据，机器人可以全部掌握，并汇总分析后给出建议。"
            )
          ]
        ),
        _c(
          "div",
          {
            staticClass: "p3 delay2 mt20",
            class: { fadeDown: _vm.isB5Visible }
          },
          [
            _c("img", {
              attrs: { src: require("../../../assets/web/2s-img3.png") }
            })
          ]
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b6" } }, [
      _c("div", { staticClass: "w" }, [
        _c(
          "div",
          {
            staticClass: "msg blue delay1",
            class: { fadeUp: _vm.isB6Visible }
          },
          [_vm._v("主人，7点到了记得看新闻联播哦")]
        ),
        _c(
          "div",
          { staticClass: "msg2 delay2", class: { fadeUp: _vm.isB6Visible } },
          [_vm._v("维拉，7点提醒我看新闻联播")]
        ),
        _c(
          "div",
          { staticClass: "p1 delay3", class: { fadeUp: _vm.isB6Visible } },
          [_vm._v("智慧关爱")]
        ),
        _c(
          "div",
          { staticClass: "p3 delay4 mt10", class: { fadeUp: _vm.isB6Visible } },
          [
            _vm._v("任何小事，随口交代，机器人自会帮你记着。"),
            _c("br"),
            _vm._v(" 帮你语音提醒家人，关爱更进一步。")
          ]
        )
      ])
    ]),
    _c("div", { attrs: { id: "info-b7" } }, [
      _c("div", { staticClass: "w" }, [
        _c("div", { staticClass: "p1", class: { fadeUp: _vm.isB7Visible } }, [
          _vm._v("运动自如")
        ]),
        _c(
          "div",
          { staticClass: "p3 delay1 mt10", class: { fadeUp: _vm.isB7Visible } },
          [
            _vm._v("工业级TPU橡胶，子午线轮胎。"),
            _c("br"),
            _vm._v("粉末冶金工艺，行星轮减速器。"),
            _c("br"),
            _vm._v("摇杆式操作，享受控制机器人运动的快感。")
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d356b33", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d356b33","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/robot/2s/info.vue
// module id = vffT
// module chunks = 0